// extracted by mini-css-extract-plugin
export var avainlippu = "footer-module--avainlippu--36746";
export var callToAction = "footer-module--callToAction--0f07a";
export var footerWrapper = "footer-module--footerWrapper--77c40";
export var linkDivider = "footer-module--linkDivider--b0283";
export var linkGrid = "footer-module--linkGrid--8da3a";
export var linkWrapper = "footer-module--linkWrapper--6fdac";
export var logoIcon = "footer-module--logoIcon--fc79a";
export var logoIconWrapper = "footer-module--logoIconWrapper--cc87a";
export var rightArrowSvg = "footer-module--rightArrowSvg--4a2b2";